import React from 'react';
import { RetrieveRequest } from '../../../utilities/services/RequestService';
import { getOptionsDeactive } from '../../../utilities/actions/Helpers';
import { Alert } from '../..';
import SelectBase from './SelectBase';
import { api } from '../../../config/Services';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            options: []
        }
    }

    componentDidMount() {
        if (this.props.forceRender) {
            this.retrieveData();
        }
    }

    retrieveData(criteria = {}, inactivefield = {}, actionspage = 'create', specialLabel) {
        let url = api.url.awardmaster.list;
        let sort = { partnername: 'asc' };
        let paging = { limit: -1, page: 1 };
        criteria.active = true;
        this.setState({ isLoading: true });
        RetrieveRequest(url, criteria, sort, paging).then((response) => {
            const { status = {} } = response || {};
            if (status.responsecode === '0000') {
                var options = response.result.map(({ awardcode, name }) => {
                    if (specialLabel) {
                        return {
                            label: `${awardcode} - ${name}`,
                            value: awardcode
                        };
                    } else {
                        return {
                            label: awardcode,
                            value: awardcode
                        };
                    }
                });

                //if options deactive
                const { partnercode, partnername } = inactivefield;
                if (partnercode) {
                    options = getOptionsDeactive(actionspage, options, partnercode, partnername);
                }

                this.setState({ options, isLoading: false });
            } else {
                Alert.error(response.status.responsemessage);
            }
        });
    }

    render() {
        return (<SelectBase {...this.props} options={this.state.options} isLoading={this.state.isLoading} />)
    }
}

export default App;